import {Grid, Typography, Paper, MuiIcons} from "@leap4/frontend";
import React, {useEffect, useState} from "react";
import {DateTime} from "luxon";

const { Update: UpdateIcon } = MuiIcons;

export interface IPropsLastUpdatedAt {
    updatedAt: Date
}

export const LastUpdatedAt = (props: IPropsLastUpdatedAt) => {

    const lastUpdatedPhrase = () => {
        let strToReturn = 'Last Updated '
        const luxonDate = DateTime.fromJSDate(props.updatedAt)
        const daysDiff = Math.floor(Math.abs(luxonDate.diffNow('days').get('days')))
        switch (daysDiff) {
            case 0:
                strToReturn += `Today At `
                break;
            case 1:
                strToReturn += 'Yesterday At '
                break;
            default:
                strToReturn += `At ${luxonDate.toLocaleString()}, `
        }
        const updatedAt = new Date(props.updatedAt);
        const hours = updatedAt.getHours() > 9 ? updatedAt.getHours() : `0${updatedAt.getHours()}`;
        const minutes = updatedAt.getMinutes() > 9 ? updatedAt.getMinutes() : `0${updatedAt.getMinutes()}`;
        strToReturn += `${hours}:${minutes}`
        return strToReturn
    }

    return (
        <Paper elevation={5} style={{padding: '8px 12px', borderRadius: "16px", boxShadow: "none"}}>
            <Grid container direction={"row"} gap={1}
                  style={{marginLeft: 0, justifyContent: 'center'}}>
                <UpdateIcon/>
                <Typography fontFamily={"Quicksand"} fontWeight={600} style={{textAlign: 'center'}}>{lastUpdatedPhrase()}</Typography>
            </Grid>
        </Paper>
    )
}